import { createBrowserRouter, createHashRouter } from "react-router-dom";

import { AppShellLayout } from "@/layouts/app-shell-layout";

export const router = createHashRouter([
  {
    path: "/",
    element: <AppShellLayout />,
    handle: { breadcrumb: "Beranda" },
    children: [
      {
        index: true,
        lazy: async () => ({
          Component: (await import("@/pages/home-page")).HomePage,
        }),
      },
      {
        path: "regional-intelligence",
        lazy: async () => ({
          Component: (await import("@/pages/regional-intelligence-page"))
            .RegionalIntelligencePage,
        }),
        handle: { breadcrumb: "Intelijen Regional" },
      },
      {
        path: "dashboard",
        lazy: async () => ({
          Component: (await import("@/pages/dashboard-page")).DashboardPage,
        }),
        handle: { breadcrumb: "Dasbor" },
      },
      {
        path: "fiscal",
        lazy: async () => ({
          Component: (await import("@/pages/fiscal-page")).FiscalPage,
        }),
        handle: { breadcrumb: "Fiskal" },
      },
      {
        path: "tkd",
        lazy: async () => ({
          Component: (await import("@/pages/tkd-page")).TkdPage,
        }),
        handle: { breadcrumb: "TKD" },
      },
      {
        path: "dana-desa",
        lazy: async () => ({
          Component: (await import("@/pages/dana-desa-page")).DanaDesaPage,
        }),
        handle: { breadcrumb: "Dana Desa" },
      },
      {
        path: "apbn",
        lazy: async () => ({
          Component: (await import("@/pages/apbn-page")).ApbnPage,
        }),
        handle: { breadcrumb: "APBN" },
      },
      {
        path: "ikpa",
        lazy: async () => ({
          Component: (await import("@/pages/ikpa-page")).IkpaPage,
        }),
        handle: { breadcrumb: "IKPA" },
      },
      {
        path: "kur",
        lazy: async () => ({
          Component: (await import("@/pages/kur-page")).KurPage,
        }),
        handle: { breadcrumb: "KUR" },
      },
      {
        path: "macro",
        lazy: async () => ({
          Component: (await import("@/pages/macro-page")).MacroPage,
        }),
        handle: { breadcrumb: "Makro" },
      },
      {
        path: "media-analytics",
        lazy: async () => ({
          Component: (await import("@/pages/media-page")).MediaPage,
        }),
        handle: { breadcrumb: "Media Analytics" },
      },
      {
        path: "executive-briefs",
        lazy: async () => ({
          Component: (await import("@/pages/executive-briefs-page"))
            .ExecutiveBriefsPage,
        }),
        handle: { breadcrumb: "Brief Eksekutif" },
      },
      {
        path: "ai",
        lazy: async () => ({
          Component: (await import("@/pages/ai-page")).AiPage,
        }),
        handle: { breadcrumb: "Lab AI" },
      },
      {
        path: "governance",
        lazy: async () => ({
          Component: (await import("@/pages/governance-page")).GovernancePage,
        }),
        handle: { breadcrumb: "Tata Kelola" },
      },
    ],
  },
]);
